import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

export default class EventService {
  private schoolUuid: string;

  constructor(schoolUuid: string) {
    this.schoolUuid = schoolUuid;
  }

  private basePath(): string {
    return `/v1/schools/${this.schoolUuid}/events`;
  }

  private backofficeBasePath(): string {
    return `/school-backoffice-bff/v1/schools/${this.schoolUuid}/events`;
  }

  async listBackoffice(limit: number = 20, offset: number = 0): Promise<BackofficeEventListItemDto[]> {
    const response = await HttpService.getJson<EdudoResponse<BackofficeEventListItemDto[]>>(
      `${this.backofficeBasePath()}?limit=${limit}&offset=${offset}`
    );

    return response.data;
  }

  // A tela de listagem não pagina: percorre as páginas até a última (o BFF
  // aceita no máximo 100 por página).
  async listAllBackoffice(): Promise<BackofficeEventListItemDto[]> {
    const pageSize = 100;
    const all: BackofficeEventListItemDto[] = [];

    for (let offset = 0; ; offset += pageSize) {
      const page = await this.listBackoffice(pageSize, offset);
      all.push(...page);
      if (page.length < pageSize) return all;
    }
  }

  async getBackoffice(eventId: string): Promise<BackofficeEventDetailDto> {
    const response = await HttpService.getJson<EdudoResponse<BackofficeEventDetailDto>>(
      `${this.backofficeBasePath()}/${eventId}`
    );

    return response.data;
  }

  // Rota canônica: devolve os uuids crus (image/recipients) no formato que o PUT
  // espera de volta. É a que o formulário de edição usa, e não a do BFF.
  async getEvent(eventId: string): Promise<EventDto> {
    const response = await HttpService.getJson<EdudoResponse<EventDto>>(`${this.basePath()}/${eventId}`);

    return response.data;
  }

  async createEvent(data: EventRequest): Promise<EventDto> {
    const response = await HttpService.postJson<EdudoResponse<EventDto>>(this.basePath(), data);

    return response.data;
  }

  async updateEvent(eventId: string, data: EventRequest): Promise<EventDto> {
    const response = await HttpService.putJson<EdudoResponse<EventDto>>(
      `${this.basePath()}/${eventId}`,
      data
    );

    return response.data;
  }

  async deleteEvent(eventId: string): Promise<void> {
    await HttpService.delete(`${this.basePath()}/${eventId}`);
  }
}
